const SidebarData = [
    {
        label: "Menü",
        isMainMenu: true,
    },
    {
        label: "Ana Sayfa",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
        bgcolor: "bg-primary",
        isHasArrow: true,
    },
    {
        label: "Ekle",
        isMainMenu: true,
    },
    {
        label: "Tahmin-Kupon Ekle",
        icon: "mdi mdi-plus",
        isHasArrow: true,
        url: "/add",
    },

    {
        label: "Vip İçin Ekle",
        icon: "mdi mdi-diamond-stone",
        isHasArrow: true,
        url: "/add-vip",
    },
    
    {
        label: "Düzenlemeler",
        isMainMenu: true,
    },

    {
        label: "Tahminler",
        icon: "mdi mdi-notebook-edit",
        isHasArrow: true,
        url: "/predictions",
    },

    {
        label: "Kuponlar",
        icon: "mdi mdi-note-text",
        isHasArrow: true,
        url: "/coupons",
    },

    {
        label: "Vip Maçlar",
        icon: "mdi mdi-diamond-stone",
        isHasArrow: true,
        url: "/vip-matches",
    },
    
    {
        label: "KULLANICILAR",
        isMainMenu: true,
    },

    {
        label: "Kullanıcılar (Mentor)",
        icon: "mdi mdi-account",
        isHasArrow: true,
        url: "/users/mentor",
    },
    
    {
        label: "Kullanıcılar (Bullco)",
        icon: "mdi mdi-account",
        isHasArrow: true,
        url: "/users/bullco",
    },

    {
        label: "Kullanıcılar (Zixo)",
        icon: "mdi mdi-account",
        isHasArrow: true,
        url: "/users/zixo",
    },

    {
        label: "Kullanıcılar (Testudo)",
        icon: "mdi mdi-account",
        isHasArrow: true,
        url: "/users/testudo",
    },

    {
        label: "Kullanıcılar (Fox)",
        icon: "mdi mdi-account",
        isHasArrow: true,
        url: "/users/fox",
    },

    {
        label: "Demeter Fox Ekle",
        isMainMenu: true,
    },
    {
        label: "Fox Tahmin-Kupon Ekle",
        icon: "mdi mdi-plus",
        isHasArrow: true,
        url: "/bullcoadd",
    },

    {
        label: "Fox Vip İçin Ekle",
        icon: "mdi mdi-diamond-stone",
        isHasArrow: true,
        url: "/bullcoadd-vip",
    },
    
    {
        label: "Fox Düzenlemeler",
        isMainMenu: true,
    },

    {
        label: "Fox Tahminler",
        icon: "mdi mdi-notebook-edit",
        isHasArrow: true,
        url: "/bullcopredictions",
    },

    {
        label: "Fox Kuponlar",
        icon: "mdi mdi-note-text",
        isHasArrow: true,
        url: "/bullcocoupons",
    },

    {
        label: "Fox Vip Maçlar",
        icon: "mdi mdi-diamond-stone",
        isHasArrow: true,
        url: "/vip-matches-bullco",
    },

]
export default SidebarData;
